import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
// import Swiper core and required components
import SwiperCore, {EffectFade, Lazy, Pagination, Thumbs, Navigation} from 'swiper';
import {Swiper} from 'swiper/react';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import clsx from "clsx";
/*demo image*/


// install Swiper components
SwiperCore.use([Pagination, Thumbs, EffectFade, Lazy, Navigation]);

const Slider = ({ contrast, children, ...swiperProps }) => {
    const classes = useStyles();

    // const paginationEl = _uniqueId("swiper-pagination-");
    return (
        <Swiper
            {...swiperProps}
            navigation
            // onSwiper={(swiper) => console.log(swiper)}
            // onSlideChange={() => console.log('slide change')}
            style={{width: `100%`}}
            className={clsx(classes.sliderRoot, {
                [classes.contrast]: contrast,
            })}
        >
            {children}
        </Swiper>
    );
};

const useStyles = makeStyles((theme) => ({

    sliderRoot: {
        '--swiper-navigation-size': '32px',
        "& .swiper-button-next, & .swiper-button-prev": {
            color: '#fff',
        },
    },
    contrast: {
        "& .swiper-button-next, & .swiper-button-prev": {
            color: '#000',
        },
    },
}))

export default Slider
